class MdlpService {
  connect() {
    const url = 'Mdlp/EventRegister';

    this.eventSource = new EventSource(url, {
      withCredentials: true
    });

    this.initListeners();
  }

  closeConnection() {
    this.eventSource.close();
  }

  initListeners() {
    this.eventSource.onmessage = (eventMessage) => {
      if (!this.isEventMessageValid(eventMessage)) return;

      const frameData = JSON.parse(eventMessage.data);
      this.handleEventActions(frameData);
    };
  }

  isEventMessageValid(eventMessage) {
    const frameData = JSON.parse(eventMessage?.data || JSON.stringify({}));

    return eventMessage.type === 'message' && frameData.close;
  }

  handleEventActions(frameData) {
    const { close } = frameData;

    if (close) {
      Monet.Authentication.logoutMdlp();
    }
  }
}

export default MdlpService;
